import { makeStyles } from '@material-ui/core/styles';
import { fill, fillHover } from '../../../utils/contrastSvgAttributes';
import { highContrastMode } from '../../../utils/highContrastChecker';

export const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
  },
  cardDownloadIcon: {
    minWidth: 'unset',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    width: '35px',
    height: '35px',
    '&:hover': {
      backgroundColor: 'rgba(202, 202, 252, 0.3)',
    },
    '&:disabled': {
      '& path': {
        fill:  highContrastMode ? 'white' : 'rgba(44, 45, 62, 0.5)',
      },
    },
  },
  onHover: {
    '&:hover': {
      '& path': {
        fill: fillHover
      },
    },
  },
  disabledAction: {
    position: 'absolute',
    top: '1px', 
    left: '1px', 
    height:'33%',
    width:'33%',
  },
  filledIcon: {
    '& path': {
      fill: fill,
    },
  },
}));
